import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const emailCampaignsIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "80",
        height: "80",
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "80",
                height: "80",
                rx: "9",
                fill: "#00D2D2"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M46.5498 38.3041H27.2893C26.3449 38.3041 25.5793 39.0697 25.5793 40.014C25.5793 40.9584 26.3449 41.7239 27.2893 41.7239H45.6335L40.2312 61.8854H36.8854C24.7984 61.8854 15 52.087 15 40C15 27.913 24.7984 18.1146 36.8854 18.1146H51.9596L46.5498 38.3041Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M53.2716 61.8854H44.0044L49.4067 41.7239C54.0824 41.7239 57.4855 46.159 56.2754 50.6754L53.2716 61.8854Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M61.9888 29.3526C60.574 34.6326 55.7893 38.3041 50.323 38.3041L55.7328 18.1146H65L61.9888 29.3526Z",
                fill: "white"
            })
        ]
    });
